import { Route, Switch } from 'react-router-dom'

import { useDisableSalesforceChat } from 'core/ui/hooks/useDisableSalesforceChat'

import { BulkSpotQuotePage } from './bulk/BulkSpotQuotePage'
import { SingleSpotQuotePage } from './SingleSpotQuotePage'

type SpotQuotePageProps = {
  match: {
    path: string
  }
}

export default function SpotQuotePage({ match }: SpotQuotePageProps): JSX.Element {
  const { path } = match

  useDisableSalesforceChat()

  return (
    <Switch>
      <Route path={`${path}/:id/single`} component={SingleSpotQuotePage} exact />
      <Route path={`${path}/:id/bulk`} component={BulkSpotQuotePage} exact />
    </Switch>
  )
}
